/**
 * Páginas: ficha, auditoría, borradores, citas, clínicas, veterinario.
 */
// --- Ficha de mascota: información básica ---
export const petDetail = {
  basicInfoTitle: 'Información Básica',
  usageClinicalSummary: 'Uso de resumen clínico',
  uploadedFiles: 'Archivos subidos',
  filesAvailable: (n: number) => `${n} disponibles`,
  remainingThisMonth: (n: number) => `${n} restantes este mes`,
} as const;

export const userAudit = {
  pageTitle: 'Auditoría de usuarios',
  pageSubtitle: 'Cambios realizados sobre usuarios del sistema',
  scopeNote: 'Incluye acciones sobre cuentas (panel Admin), mascotas (crear/editar/eliminar), controles médicos, vacunas, registros médicos y controles de peluquería. Al filtrar por usuario se muestran también sus acciones sobre mascotas y controles.',
  backToPanel: 'Volver al panel',
  searchPlaceholder: 'Usuario (email o nombre)',
  dateFrom: 'Desde',
  dateTo: 'Hasta',
  actionTypeLabel: 'Tipo de acción',
  allActions: 'Todas las acciones',
  loadError: 'Error al cargar auditoría. Intenta de nuevo.',
  colDate: 'Fecha',
  colWho: 'Quién',
  colAction: 'Acción',
  colAffectedUser: 'Usuario / recurso afectado',
  colDescription: 'Descripción',
  noRecords: 'No hay registros de auditoría con los filtros aplicados.',
  noRecordsWithFilterHint: 'Si filtraste por un usuario y no ves resultados, puede que aún no haya acciones registradas para ese usuario. La auditoría solo registra cuando se guarda (clic en Guardar, activar, desactivar, resetear IA, etc.), no al solo abrir o editar sin guardar. Prueba sin filtro para ver todas las acciones.',
  totalRecords: (n: number) => `Total: ${n} registro(s)`,
  pageOf: (current: number, total: number) => `Página ${current} de ${total}`,
  previous: 'Anterior',
  next: 'Siguiente',
  administrator: 'Administrador',
} as const;

// --- Borradores (dashboard) ---
export const drafts = {
  title: 'Borradores Guardados',
  searchPlaceholder: 'Buscar borradores por nombre de mascota o dueño...',
  noResults: 'No se encontraron borradores que coincidan con tu búsqueda.',
} as const;

// --- Veterinario: resultados de búsqueda ---
export const veterinarianSearch = {
  ownerLabel: 'Dueño:',
  clinicLabel: 'Clínica:',
  hasAllergies: 'Tiene alergias',
  viewFullRecord: 'Ver Ficha Completa',
  searchingMessage: 'Por favor espera mientras buscamos las mascotas',
  searchPrompt: 'Busca una mascota',
} as const;

// --- Citas ---
export const appointments = {
  loadError: 'Error al cargar las citas',
  pageSubtitle: 'Gestiona tus citas veterinarias',
  newAppointment: 'Nueva Cita',
  noAppointments: 'No hay citas programadas',
  noAppointmentsFilter: 'No se encontraron citas con los filtros seleccionados.',
} as const;

// --- Clínicas ---
export const clinics = {
  managementTitle: 'Gestión de Clínicas',
  managementSubtitle: 'Administra las clínicas veterinarias del sistema',
  newClinic: 'Nueva Clínica',
  registeredClinics: 'Clínicas registradas',
  noClinics: 'No hay clínicas registradas',
  noClinicsHint: 'Comienza creando la primera clínica veterinaria',
  createFirstClinic: 'Crear Primera Clínica',
} as const;

// --- Dashboard veterinario ---
export const veterinarianDashboard = {
  dashboardTitle: 'Dashboard Veterinario',
  dashboardSubtitle: 'Gestiona tus citas y busca mascotas por microchip o RUT del dueño',
} as const;

// --- Referidos (dueño) ---
export const referralsPage = {
  seoTitle: 'Referidos | Mi Huellita Digital',
  seoDescription:
    'Invita amigos: ellos obtienen días extra de prueba y tú descuento en tu suscripción cuando se queden.',
  heading: 'Programa de referidos',
  intro:
    'Comparte tu código o QR. Quien se registre con tu enlace obtiene días extra de prueba. Si mantiene su suscripción activa el tiempo configurado, tú recibes un descuento en tu próximo cobro.',
  errorLoad: 'No se pudo cargar la información de referidos. Intenta de nuevo más tarde.',
  yourCodeLabel: 'Tu código',
  copyCode: 'Copiar código',
  registerLink: 'Enlace de registro',
  copyLink: 'Copiar enlace',
  qrLabel: 'QR para compartir',
  refereeTrialDaysLabel: 'Días extra de prueba (referido)',
  referrerDiscountLabel: 'Tu descuento en suscripción',
  referrerMonthsLabel: 'Meses pagados del referido',
  countLabel: 'Registros con tu código',
  pendingRewardsLabel: 'Descuentos pendientes',
} as const;
